import { defineMessage } from 'services/localization';

export const messages = {
    hiddenFieldAccessLevel: defineMessage('hidden'),
    readOnlyFieldAccessLevel: defineMessage('readonly'),
    editableFieldAccessLevel: defineMessage('editable'),
    mandatoryFieldAccessLevel: defineMessage('mandatory'),
    fieldLevelsHeader: defineMessage('header'),
    fieldLevelsLines: defineMessage('lines'),
    fieldLevelsHeaderAndLindes: defineMessage('header_and_lines'),
};
